module.exports = __webpack_public_path__ + "37144651d85729ebf70457380de47d46.MP3";